import TlUserSelect from "./src/index.vue";

TlUserSelect.install = function (Vue) {
  Vue.component(TlUserSelect.name, TlUserSelect);
};

export default TlUserSelect;
